export const CTA_QUERY_PARAM = 'nocta';
